import { Key, useState, useEffect, RefObject } from "react";
import { MenuListComponentProps } from "react-select";
import { detect } from "detect-browser";

import { Region } from "../CountrySelect";
import { Checkbox } from "../../Checkbox/Checkbox";
import classes from "../CountrySelect.module.scss";

const filterCountries = (
  regions: Region[],
  countrySelectRef: RefObject<any>
) => {
  const filteredValues =
    regions &&
    (
      regions.map((region) => ({
        ...region,
        fields: {
          ...region.fields,
          countries: region.fields?.countries.filter((country) =>
            country.fields?.name
              ?.toLowerCase()
              .includes(
                (
                  countrySelectRef.current?.state.inputValue as string
                ).toLowerCase()
              )
          ),
        },
      })) as Region[]
    ).filter((region) => region.fields?.countries?.length);

  return filteredValues?.length ? filteredValues : [];
};

const renderCountryList = ({ selectOption, hasValue, selectProps }: any) => {
  return filterCountries(selectProps.regions, selectProps.countrySelectRef).map(
    ({ fields: { name: regionName, countries } }, index: number) => {
      return (
        <div key={`${regionName}-${index}`}>
          <div className={classes.selectMenuTitle}>{regionName}</div>
          {countries.map(({ fields: { name: value, label } }, index: Key) => {
            if (value === "Country") return null;
            // console.log("selected countries", selectProps.selectedCountries);
            const isSelected =
              hasValue && selectProps.selectedCountries.includes(String(value));
            return (
              <div
                key={`${value}-${index}`}
                className={`${classes.selectMenuItem} ${
                  isSelected ? classes.selected : ""
                }`}
                onClick={() => {
                  selectOption({
                    label,
                    value,
                  });
                }}
              >
                <Checkbox isSelected={isSelected} />
                {label}
              </div>
            );
          })}
        </div>
      );
    }
  );
};

const MenuList = ({ selectOption, getValue, hasValue, selectProps }: MenuListComponentProps<any, boolean>) => {
  const [backgroundNoBlur, setBackgroundNoBlur] = useState<boolean>(false);

  useEffect(() => {
    if (detect()?.name === 'firefox' || detect()?.name === 'ie') {
      setBackgroundNoBlur(true);
    }
  }, []);

  return (
    <div className={`
      ${classes.selectMenuList}
      ${backgroundNoBlur ? classes.noBlur : ''}
    `}>
      { filterCountries(selectProps.regions, selectProps.countrySelectRef)?.length > 0 ? (
        <>
          <div
            className={classes.selectMenuItem + ' ' + classes.selectMenuItemTopIteam}
          >
            { selectProps.countryNotSelected }
          </div>
          { renderCountryList({ selectOption, getValue, hasValue, selectProps }) }
        </>
      ) :
        <div className={classes.selectNoOptions}>
          { selectProps.countryNoResults }
        </div>
      }
    </div>
  )
}

export default MenuList;